
import React, { Fragment, useEffect, useState } from 'react';

import { Route, match, Switch } from 'react-router-dom';

import MarkdownPreview from '@uiw/react-markdown-preview';

import '@uiw/react-markdown-preview/markdown.css'; // Default styles


// import '@uiw/react-markdown-preview/themes/github.css'; // Optional theme



import { AiMessage } from "./AiAgent";




const AiMarkdown = (props: { message: AiMessage }) => {

  return (
    <>
      <MarkdownPreview
        source={props.message.content}
        wrapperElement={{
          "data-color-mode": "light"
        }}
      />
    </>
  );
};




export {
  AiMarkdown
};
